export function registerEventHandlers(handlers, elem = window) {
    for (const [e, h] of Object.entries(handlers)) {
        elem.addEventListener(e, h);
    }
};
export function removeEventHandlers(handlers, elem = window) {
    for (const [e, h] of Object.entries(handlers)) {
        elem.removeEventListener(e, h);
    }
};